import userApi from '@/api/users'

export default {
  state: {
    preschoolTeacherDetails: {}
  },

  mutations: {
    setPreschoolTeacherDetails(state, teacher) {
      state.preschoolTeacherDetails = teacher
    }
  },

  actions: {
    async getPreschoolTeacher({ commit }, pedagogId) {
      try {
        const { data } = await userApi.getPreschoolTeacher({
          filter: {
            id: pedagogId
          }
        })

        if (data?.success) {
          commit('setPreschoolTeacherDetails', data.result.rows[0])
        }
      } catch (error) {
        console.warn(error)
      }
    }
  },

  getters: {
    preschoolTeacherDetails: ({ preschoolTeacherDetails }) => preschoolTeacherDetails
  }
}
